<script lang="ts">
	import { _ } from 'svelte-i18n';
	import type { Post } from '$lib/api/rpc';
	import { stripTags } from '$lib/utils/strings';

	export let block: Post;
	export let editable = false;
</script>

<div class="contentContainer">
	<div class="title px-title">
		{#if !editable}
			{block.title}
		{:else}
			<input placeholder={$_('composer.placeholder.enter.title')} bind:value={block.title} />
		{/if}
	</div>
	<div class="description titleFontSize">
		<p>
			{#if !editable && block.description}
				{stripTags(['.*?'], block.description.trim())}
			{:else if editable}
				<textarea
					placeholder={$_('composer.placeholder.add.a.description')}
					bind:value={block.description}
				/>
			{/if}
		</p>
	</div>
	{#if block.source && block.author}
		<div class="metadata">
			<div class="sourceContainer">
				{#if !editable && block.source.network}
					<span>{block.source.network}</span>
				{:else if editable}
					<input
						placeholder={$_('composer.placeholder.enter.network')}
						bind:value={block.source.network}
					/>
				{/if}
			</div>
			{#if block.source.network && block.author.name}
				<span class="delimeter">-</span>
			{/if}
			<div class="sourceContainer">
				{#if !editable && block.author.name}
					<span>{block.author.name}</span>
				{:else if editable}
					<input
						placeholder={$_('composer.placeholder.enter.author')}
						bind:value={block.author.name}
					/>
				{/if}
			</div>
		</div>
	{/if}
</div>

<style>
	.contentContainer {
		border-block-start: 1px solid rgb(240 240 240);
		padding-inline-start: var(--gutterSmall);
	}

	.sourceContainer {
		padding-block: 5px 4px;
		padding-inline: 0;
		overflow: hidden;
	}

	.sourceContainer span {
		color: var(--hubDetailFontColor);
		font: var(--hubDetailFont);
		font-size: 13px !important;
		font-weight: 400;
		line-height: 1.8rem;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.metadata {
		display: flex;
		align-items: center;
		justify-content: start;
		padding-block-end: var(--gutterSmall);
	}

	.metadata input {
		inline-size: 11rem;
	}

	.metadata,
	.contentContainer input,
	textarea {
		border: none;
		outline: none;
		background: none;
		resize: none;
	}

	textarea {
		inline-size: 100%;
		font-size: 12px;
	}

	.metadata .delimeter {
		margin-inline: 4px;
		color: var(--hubDetailFontColor);
		font: var(--hubDetailFont);
	}

	.title {
		inline-size: 100%;
		padding-block: 7px 2px;
		padding-inline: 0;
		overflow: hidden;
		color: var(--hubHeadlineFontColor);
		font-size: 20px;
		line-height: 2.7rem;
		overflow-wrap: break-word;
	}

	.title input {
		inline-size: 100%;
		color: var(--hubHeadlineFontColor);
		font-size: 20px;
		font-weight: bold;
		letter-spacing: 0;
		line-height: 2.7rem;
	}

	.description {
		padding-block: 5px 4px;
		padding-inline: 0;
		color: var(--hubBodyFontColor);
		font: var(--hubBodyFont);
	}

	.description p {
		max-block-size: 72px;
		margin: 0;
		color: var(--bodyFontColor);
		font-size: 12px;
		font-weight: 400;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}

	.titleFontSize {
		font-size: var(--fontSizeSmaller);
	}
</style>
